var config = {
  basePath: '/',
  basePathImg: '/bundles/ulekare/img/',
  bowerPath: '/bundles/ulekare/bower/',
  cacheVersion: 4,
  googleApiKey: 'AIzaSyBCo-S3dZyQ1-DMPBtArq5W0TMIkIDepQ4'
}

var UL = function () {

  var callbacks = {
    'jquery': [],
    'modules': []
  };

  var jqueryLoaded = false;

  var registerModule = function (module) {
    callbacks.modules.push(module);
  };

  var initCallbacks = function () {
    // modules
    for (i in callbacks.modules) {
      if (callbacks.modules[i].init) {
        callbacks.modules[i].init();
      }
    }
    // jquery load callbacks
    callJqueryCallbacks();
  };

  var callJqueryCallbacks = function () {
    // jquery load callbacks
    for (i in callbacks.jquery) {
      callbacks.jquery[i]($);
    }
  };

  var setCacheBusting = function (input) {
    var cb = config.cacheVersion;
    return input.indexOf('?') > 0 ? input + '&' + cb : input + '?' + cb;
  };

  var getScriptWithoutPromise = function (loadScript, doneCallback, failCallback) {

    var getType = function (fileName) {
      var parse = fileName.split(".");
      var suffix = (parse[parse.length - 1]).split("?")[0];
      return suffix;
    };

    var type = getType(loadScript);

    if (type == 'js') {
      var script = document.createElement('script');
      script.src = loadScript;
    } else if (type == 'css') {
      var script = document.createElement('link');
      script.href = loadScript;
      script.rel = 'stylesheet';
    } else {
      return;
    }

    script.onload = function () {
      if (doneCallback !== undefined) {
        doneCallback();
      }
    };
    script.onerror = function () {
      console.log('ERROR loading resource', loadScript)
      if (failCallback !== undefined) {
        failCallback();
      }
    };
    document.getElementsByTagName('head')[0].appendChild(script);

  };

  var getScript = function (loadScript) {

    var deferred = $.Deferred();

    var getType = function (fileName) {
      var parse = fileName.split(".");
      var suffix = (parse[parse.length - 1]).split("?")[0];
      return suffix;
    };

    var type = getType(loadScript);

    if (type == 'js') {
      var script = document.createElement('script');
      script.src = loadScript;
    } else if (type == 'css') {
      var script = document.createElement('link');
      script.href = loadScript;
      script.rel = 'stylesheet';
    } else {
      deferred.reject();
      return deferred.promise;
    }

    script.onload = function () {
      deferred.resolve();
    };
    script.onerror = function () {
      console.log('ERROR loading resource', loadScript)
      deferred.reject();
    };
    document.getElementsByTagName('head')[0].appendChild(script);

    return deferred.promise();

  };

  var getScriptCdnWithoutPromise = function (cdnScript, localScript, callback) {
    getScriptWithoutPromise(cdnScript, callback, function () {
      getScriptWithoutPromise(setCacheBusting(localScript), callback);
    });
  };

  var getScriptCdn = function (cdnScript, localScript) {
    var deferred = $.Deferred();
    getScript(cdnScript).then(function () {
      deferred.resolve();
    }).fail(function () {
      getScript(setCacheBusting(localScript)).then(function () {
        deferred.resolve();
      });
    });
    return deferred.promise();
  };

  var featureTestAll = function () {
    var $el = $('html');
    $.each(feature, function (index, value) {
      if (!value) {
        $el.addClass('not-' + index);
      }
    });
  };

  var jqueryLibrary = function (callback) {
    getScriptCdnWithoutPromise(
      '//cdnjs.cloudflare.com/ajax/libs/jquery/1.12.4/jquery.min.js',
      config.bowerPath + 'jquery/dist/jquery.min.js',
      callback
    );
  };

  var javascriptLibraries = function () {
    var promises = [
      getScriptCdn(
        '//cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment-with-locales.min.js',
        config.bowerPath + 'moment/min/moment-with-locales.min.js'
      ),
      getScriptCdn(
        '//cdnjs.cloudflare.com/ajax/libs/jquery-scrollTo/2.1.2/jquery.scrollTo.min.js',
        config.bowerPath + 'jquery.scrollTo/jquery.scrollTo.min.js'
      )
    ];
    return $.when(promises);
  };

  var onJqueryLoad = function (callback) {
    callbacks.jquery.push(callback);
    if (jqueryLoaded === true) {
      callJqueryCallbacks();
    }
  };

  var init = function () {
    jqueryLibrary(function () {
      jqueryLoaded = true;
      javascriptLibraries().then(function () {
        featureTestAll();
        initCallbacks();
      });
    });
  };

  return {
    init: init,
    register: registerModule,
    getScript: getScriptWithoutPromise,
    getScriptCdn: getScriptCdnWithoutPromise,
    onJqueryLoad: onJqueryLoad
  };
}();
